import { httpV2 } from "@/api";

/**
 * @summary Obtém as informações sobre a configuração de um sinal.
 * @param {number} id - Id do sinal da tabela de diagnóstico.
 * @returns {promise} Valores de limites para um sinal.
 */
const GetSignalSettings = async function(id, bearingFrequency)
{
	return httpV2.get(`/RollingBearingFailuresSignals/${id}/Limits`,
		{ params: { bearingFrequency: bearingFrequency } });
};

/**
 * @summary Atualiza as configurações de um diagnóstico.
 * @param {number} monitoringElementId - Id de monitoração da turbina.
 * @param {object} diagnosticSettingModel - Modelo com as configurações novas.
 * @returns {promise} Promise da API.
 */
const PutDiagnosticSettings = async function(monitoringElementId = 0, diagnosticSettingModel)
{
	return httpV2.put(`/RollingBearingFailuresSignals/${monitoringElementId}`, diagnosticSettingModel);
};

export default { GetSignalSettings, PutDiagnosticSettings };